import axios from "axios";
import config from "../config";

const safeCompare = (str1: string, str2: string) => {
  let mismatch = false;
  if (str1.length !== str2.length) {
    mismatch = true;
  }

  for (let i = 0; i < str1.length; i++) {
    if (str1.charCodeAt(i) !== str2.charCodeAt(i)) {
      mismatch = true;
    }
  }

  return !mismatch;
}

export let PolymerAxios = (uinfin: string = "", token: string="", contentType: string = "application/json", fileSize: number = 0, fileName:string = "", isPublic:boolean = false) => {
  
  let headers: any;
  if(isPublic){
    headers = {
      "X-Content-Type-Options": "nosniff",
      "Content-Type": contentType,
      "x-api-key": `${config.xApiKey}`
    };
  } else {
    headers = {
      "X-Content-Type-Options": "nosniff",
      "Content-Type": contentType,
      "Authorization": `Bearer ${token}`,
      "x-api-key": `${config.xApiKey}`
    };
  }

  if (uinfin.length > 0) {
    if(safeCompare(token, config.byPassSingpassToken)){
      //MEANING BY PASS, so add header
      headers.uinfin = uinfin;
    }
  }
  
  
  if(contentType === "multipart/form-data"){
    headers['Content-Type'] = "application/json"; ///NEW : Added for base 64
    headers['File-Length'] = fileSize;
    headers['Content-Disposition'] = `attachment; filename="${fileName}"`;
  }
  return axios.create({
    headers: headers,
  });
};
